
export default function Footer() {
  const quickLinks = [
    { name: 'About Us', href: '#about' },
    { name: 'Technologies', href: '#technologies' },
    { name: 'Projects', href: '#projects' },
    { name: 'Production', href: '#production' },
    { name: 'Contacts', href: '#contacts' },
  ];

  const socialLinks = [
    { icon: 'ri-linkedin-line', href: '#' },
    { icon: 'ri-facebook-line', href: '#' },
    { icon: 'ri-youtube-line', href: '#' },
    { icon: 'ri-instagram-line', href: '#' },
  ];

  const services = [
    { name: 'Ultrafiltration', hash: '#technologies?tech=0' },
    { name: 'Reverse Osmosis', hash: '#technologies?tech=2' },
    { name: 'ZLD Systems', hash: '#technologies?tech=1' },
    { name: 'Disc Osmosis (DTRO)', hash: '#technologies?tech=3' },
    { name: 'Spacer Tube RO (STRO)', hash: '#technologies?tech=4' },
    { name: 'Electrodeionization (EDI)', hash: '#technologies?tech=5' },
    { name: 'Component Manufacturing', hash: '#technologies' },
  ];

  return (
    <footer id="contacts" className="bg-gradient-to-br from-[#F0F6FF] via-[#F8FBFF] to-[#EAF2FF] border-t border-[#E8F0FF]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 pt-12 lg:pt-20 pb-8 lg:pb-10">

        {/* Main grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12 mb-10 lg:mb-16">

          {/* Column 1 — Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="text-[40px] lg:text-[64px] font-black leading-none text-[#0A1628] mb-1">A&amp;R</div>
            <div className="text-[10px] uppercase tracking-[3px] text-[#0066FF] font-bold mb-4 lg:mb-6">
              Innovations in Water Technologies
            </div>
            <p className="text-sm text-[#4A5568] leading-relaxed mb-6 lg:mb-8">
              Comprehensive solutions for water treatment and wastewater purification. Engineering excellence across industrial sectors.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  className="w-9 h-9 rounded-[8px] border border-[#E8F0FF] flex items-center justify-center hover:border-[#0066FF] hover:bg-[#F7FAFF] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${social.icon} text-base text-[#4A5568]`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Column 2 — Contacts */}
          <div className="col-span-1">
            <div className="text-[10px] uppercase tracking-[3px] text-[#0A1628] font-black mb-5 lg:mb-8">Contacts</div>
            <div className="space-y-4 lg:space-y-6">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-[16px] text-[#0066FF]"></i>
                </div>
                <div className="text-sm text-[#4A5568] leading-relaxed">
                  Room 701, 7/F Lucky Center<br />
                  165-171 Wanchai Road<br />
                  Wan Chai HL
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[16px] text-[#0066FF]"></i>
                </div>
                <div className="text-sm text-[#4A5568]">info@arcg.tech</div>
              </div>
            </div>
          </div>

          {/* Column 3 — Quick Links */}
          <div className="col-span-1">
            <div className="text-[10px] uppercase tracking-[3px] text-[#0A1628] font-black mb-5 lg:mb-8">Navigation</div>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    className="flex items-center gap-2 text-sm text-[#4A5568] hover:text-[#0066FF] transition-colors duration-200 cursor-pointer group"
                  >
                    <div className="w-1 h-1 rounded-full bg-[#0066FF] opacity-40 group-hover:opacity-100 transition-opacity"></div>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4 — Services */}
          <div className="col-span-1">
            <div className="text-[10px] uppercase tracking-[3px] text-[#0A1628] font-black mb-5 lg:mb-8">Technologies</div>
            <ul className="space-y-3">
              {services.map((service, i) => (
                <li key={i}>
                  <a
                    href={service.hash}
                    onClick={(e) => {
                      e.preventDefault();
                      const techIndex = service.hash.includes('tech=')
                        ? parseInt(service.hash.split('tech=')[1])
                        : -1;
                      if (techIndex >= 0) {
                        window.dispatchEvent(new CustomEvent('selectTechnology', { detail: { index: techIndex } }));
                      }
                      const el = document.getElementById('technologies');
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="flex items-center gap-2 text-sm text-[#4A5568] hover:text-[#0066FF] transition-colors duration-200 cursor-pointer group"
                  >
                    <div className="w-1 h-1 rounded-full bg-[#0066FF] opacity-40 group-hover:opacity-100 transition-opacity flex-shrink-0"></div>
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-[#E8F0FF] pt-6 lg:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-xs text-[#4A5568]">
            © 2025 A&amp;R Consulting. All rights reserved.
          </div>
          <div className="flex flex-wrap justify-center gap-4 lg:gap-8">
            <a href="#" className="text-xs text-[#4A5568] hover:text-[#0066FF] transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-xs text-[#4A5568] hover:text-[#0066FF] transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer nofollow" className="text-xs text-[#4A5568] hover:text-[#0066FF] transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}
